export default function IconSigneringDone(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 48}
      height={height ? height : width ? width : 48}
      viewBox="0 0 720 720"
    >
      <g transform="translate(4673 -6287)">
        <path
          d="M480.134-120q-74.673,0-140.41-28.339T225.359-225.261q-48.627-48.582-76.993-114.257T120-479.866q0-74.673,28.35-140.41T225.3-734.641q48.6-48.627,114.3-76.993T480-840a346.179,346.179,0,0,1,100.038,14.461,377.988,377.988,0,0,1,91.731,41.616,23.309,23.309,0,0,1,10.654,13.23,16.191,16.191,0,0,1-2.808,15.385,21.09,21.09,0,0,1-14.192,8.385,22.831,22.831,0,0,1-16.346-3.616,317.484,317.484,0,0,0-81.116-36.846A310.609,310.609,0,0,0,480-800q-133,0-226.5,93.5T160-480q0,133,93.5,226.5T480-160q133,0,226.5-93.5T800-480q0-15.224-1.269-29.5a228.358,228.358,0,0,0-4.577-29.2,22.378,22.378,0,0,1,2.269-16.354,18.76,18.76,0,0,1,12.948-9.723,17.285,17.285,0,0,1,14.86,3,22.4,22.4,0,0,1,8.692,13.231,306.457,306.457,0,0,1,5.308,33.313A340.426,340.426,0,0,1,840-480q0,74.7-28.339,140.4T734.739-225.3q-48.582,48.6-114.257,76.95T480.134-120Z"
          transform="translate(-4793 7127)"
          fill="currentColor"
        />
        <path
          d="M422.462-380.308,797.538-755.616a20.486,20.486,0,0,1,13.654-6.115q8.039-.5,14.822,6.283,6.217,6.217,6.217,13.986t-6.385,14.154l-380.769,381q-9.692,9.693-22.615,9.693t-22.616-9.693L294.308-451.846a20.137,20.137,0,0,1-6-13.769q-.385-8.154,6-14.539t14.154-6.385q7.769,0,14.153,6.385l99.847,99.846Z"
          transform="translate(-4785.231 7127)"
          fill="currentColor"
        />
      </g>
    </svg>
  );
}
